import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Avatar,
  IconButton,
  Rating,
  Grid2,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";

import { getUserPhotoSrc } from "../utils/utils";
import { ChevronLeft, ChevronRight, Star } from "@mui/icons-material";
import { mainButtonStyle } from "../static";
type RequestsDialogProps = {
  job?: any;
  requests: any[];
  open: boolean;
  handleClose: () => void;
  onAccept: (workerId: string) => void;
  onBlock: (workerId: string) => void;
};

const RequestsDialog = ({
  open,
  handleClose,
  requests,
  onAccept,
  onBlock,
}: RequestsDialogProps) => {
  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState<JSX.Element | null>(null); // eslint-disable-line

  const [currIndex, setCurrIndex] = useState(0);

  const closeDialog = () => {
    handleClose();
  };

  useEffect(() => {
    setCurrIndex(0);
  }, [requests]);

  const goBack = () => {
    const nextIndex = (currIndex - 1 + requests.length) % requests.length;
    console.log(currIndex, nextIndex);
    setCurrIndex(nextIndex);
  };

  const goForward = () => {
    const nextIndex = (currIndex + 1) % requests.length;

    setCurrIndex(nextIndex);
  };

  const requestsContent =
    requests && requests.length > 0 ? (
      <>
        {" "}
        {requests[currIndex].person.name}{" "}
        <Avatar alt="u" src={getUserPhotoSrc(requests[currIndex].personId)} />
        {requests[currIndex].person.numberOfRatings === 0 ? (
          "No ratings yet"
        ) : (
          <Rating
            name="text-feedback"
            value={requests[currIndex].person.averageRating}
            readOnly
            precision={0.5}
            emptyIcon={<Star style={{ opacity: 0.55 }} fontSize="inherit" />}
          />
        )}
        <Grid2 container>
          <Grid2 size={12}>
            <Typography variant="h6">Comments</Typography>
          </Grid2>
          <Grid2 size={12}>
            <List>
              {requests[currIndex].person.comments.map((c: any) => {
                return (
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar src={getUserPhotoSrc(c.personId)}></Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={c.comment} secondary={
                    (<Rating readOnly value={c.value}></Rating>)
                  } />
                    
                  </ListItem>
                );
              })}
            </List>
          </Grid2>
        </Grid2>
      </>
    ) : null;

  return (
    <>
      <Snackbar
        open={showMsg}
        autoHideDuration={10000000}
        onClose={() => setShowMsg(false)}
        message={msg}
      >
        <Alert
          onClose={() => setShowMsg(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>

      <Dialog open={open} onClose={closeDialog}>
        <DialogTitle>Review Job Requests</DialogTitle>
        <DialogContent>{requestsContent}</DialogContent>
        <DialogActions
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <IconButton onClick={goBack} disabled={requests.length === 1}>
            <ChevronLeft />
          </IconButton>
          <>
            {currIndex + 1} / {requests.length}
          </>
          <IconButton onClick={goForward} disabled={requests.length === 1}>
            <ChevronRight />
          </IconButton>
        </DialogActions>
        <DialogActions>
          <Button
            variant="outlined"
            color="error"
            style={mainButtonStyle}
            onClick={() => onBlock(requests[currIndex].personId)}
          >
            Block User
          </Button>

          <Button
            style={mainButtonStyle}
            onClick={() => {
              onAccept(requests[currIndex].personId);
            }}
            variant="contained"
          >
            Assign Job
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RequestsDialog;
